// extracted by mini-css-extract-plugin
export default {"container":"AreaChart_container__QOmyK"};